import React, { useState } from 'react';
import api, { getCsrfToken } from '../api/axios';
import { useNavigate, Link } from 'react-router-dom';

export default function Register() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', password: '', password_confirmation: '' });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);

    if (form.password !== form.password_confirmation) {
      setError('Password dan konfirmasi password tidak cocok.');
      return;
    }

    setLoading(true);

    try {
      await getCsrfToken();

      const res = await api.post('/api/member/register', {
        name: form.name,
        phone: form.phone,
        email: form.email || null,
        password: form.password,
        password_confirmation: form.password_confirmation,
      });

      localStorage.setItem('member_user', JSON.stringify(res.data.user));
      navigate('/my-classes');
    } catch (err) {
      const errors = err.response?.data?.errors;
      if (errors) {
        const firstError = Object.values(errors)[0];
        setError(Array.isArray(firstError) ? firstError[0] : firstError);
      } else {
        setError(err.response?.data?.message || 'Registrasi gagal.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div className="card shadow">
            <div className="card-body p-4">
              <h3 className="text-center mb-4 fw-bold">
                <span style={{ color: 'black' }}>Conex</span>
                <span style={{ color: '#F68D6E' }}>see</span>
              </h3>
              <h5 className="text-center mb-4">Daftar Peserta</h5>

              {error && <div className="alert alert-danger">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Nama Lengkap</label>
                  <input
                    name="name"
                    className="form-control"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Masukkan nama lengkap"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Nomor HP</label>
                  <input
                    name="phone"
                    className="form-control"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="Contoh: 6281234567890"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email <span className="text-muted">(opsional)</span></label>
                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Masukkan email (opsional)"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    name="password"
                    type="password"
                    className="form-control"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Minimal 6 karakter"
                    required
                    minLength="6"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Konfirmasi Password</label>
                  <input
                    name="password_confirmation"
                    type="password"
                    className="form-control"
                    value={form.password_confirmation}
                    onChange={handleChange}
                    placeholder="Ulangi password"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-dark w-100"
                  disabled={loading}
                >
                  {loading ? 'Memproses...' : 'Daftar'}
                </button>
              </form>

              <div className="text-center mt-3">
                <span className="text-muted">Sudah punya akun? </span>
                <Link to="/login">Login di sini</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
